export default {"src":"/_next/static/media/Group-25831.830be71f.svg","height":130,"width":130};